import { ValueOf } from "../types";

export const ASSISTANT_NAME_LABEL = "Assistant";
export const AUTHOR_NAME_LABEL = "You";

export const WiseOwlElementIds = {
  // WiseOwl.tsx
  WISE_OWL_CONTAINER: "WISE_OWL_CONTAINER",
  // WiseOwlChat.tsx
  WISE_OWL_CHAT_CONTAINER: "WISE_OWL_CHAT_CONTAINER",
  WISE_OWL_CHAT_FORM: "WISE_OWL_CHAT_FORM",
  WISE_OWL_CHAT_LOG_AND_INPUT_CONTAINER:
    "WISE_OWL_CHAT_LOG_AND_INPUT_CONTAINER",
  WISE_OWL_CHAT_LOG_CONTAINER: "WISE_OWL_CHAT_LOG_CONTAINER",
  WISE_OWL_CHAT_SUBMISSION_INPUT_CONTAINER:
    "WISE_OWL_CHAT_SUBMISSION_INPUT_CONTAINER",
  // ChatLog.tsx
  WISE_OWL_CHAT_LOG: "WISE_OWL_CHAT_LOG",
  // BlockRenderer
  WISE_OWL_BLOCK_RENDERER: "WISE_OWL_BLOCK_RENDERER",
  WISE_OWL_BLOCK_RENDERER_CONTAINER: "WISE_OWL_BLOCK_RENDERER_CONTAINER",
  WISE_OWL_MESSAGE_BLOCK: "WISE_OWL_MESSAGE_BLOCK",
  WISE_OWL_BUTTON_GROUP_BLOCK: "WISE_OWL_BUTTON_GROUP_BLOCK",
  WISE_OWL_LINK_GROUP_BLOCK: "WISE_OWL_LINK_GROUP_BLOCK",
  WISE_OWL_PROMPT_SUGGESTION_GROUP_BLOCK:
    "WISE_OWL_PROMPT_SUGGESTION_GROUP_BLOCK",
  WISE_OWL_TOOL_CALL_BLOCK: "WISE_OWL_TOOL_CALL_BLOCK",
  WISE_OWL_TOOL_CALL_STATUS_LINE_BLOCK: "WISE_OWL_TOOL_CALL_STATUS_LINE_BLOCK",
  WISE_OWL_LIVE_CHAT_BLOCK: "WISE_OWL_LIVE_CHAT_BLOCK",
  WISE_OWL_LOGIN_CTA_BLOCK: "WISE_OWL_LOGIN_CTA_BLOCK",
  WISE_OWL_CANNOT_LOGIN_CTA_BLOCK: "WISE_OWL_CANNOT_LOGIN_CTA_BLOCK",
  WISE_OWL_TABLE_BLOCK: "WISE_OWL_TABLE_BLOCK",
  WISE_OWL_DATA_GRID_BLOCK: "WISE_OWL_DATA_GRID_BLOCK",
  // Feedback.tsx
  WISE_OWL_FEEDBACK: "WISE_OWL_FEEDBACK",
  // CsatSurvey.tsx
  WISE_OWL_CSAT_SURVEY: "WISE_OWL_CSAT_SURVEY",
  // LegalDisclaimer.tsx
  WISE_OWL_LEGAL_DISCLAIMER: "WISE_OWL_LEGAL_DISCLAIMER",
  // IDA
  WISE_OWL_IDA_HOME_ERROR: "WISE_OWL_IDA_HOME_ERROR",
  WISE_OWL_IDA_HOME_NO_ERROR: "WISE_OWL_IDA_HOME_NO_ERROR",
};
export type WiseOwlElementIdsType = ValueOf<typeof WiseOwlElementIds>;

export const wiseOwlErrors = {
  chatCreation: "Chat creation failed",
  directLiveChatCreation:
    "Transfer to live chat failed (direct live chat creation)",
  directLiveChatNewChatCreation:
    "Create new chat failed (direct live chat creation)",
  feedbackCreation: "Create feedback failed",
  getChatSummary: "Chat summary failed",
  messageCreation: "Message send failed",
  missingPreEngagementData: "Pre-engagement data not found",
  transferToLiveChat: "Transfer to live chat failed",
};
